var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { styled } from 'goober';
import React, { forwardRef } from 'react';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
var Container = styled('div', forwardRef)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    cursor: pointer;\n    font-size: ", ";\n    color: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: start;\n\n    & > span {\n        cursor: pointer;\n        margin-left: 15px;\n    }\n"], ["\n    cursor: pointer;\n    font-size: ", ";\n    color: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: start;\n\n    & > span {\n        cursor: pointer;\n        margin-left: 15px;\n    }\n"])), function (props) { return props.theme.font.size; }, function (props) { return props.theme.colors.ui.dark; });
function FSFormSection(props, ref) {
    var _a = props.show, show = _a === void 0 ? false : _a, title = props.title, children = props.children, rest = __rest(props, ["show", "title", "children"]);
    var Icon = show ? FaChevronDown : FaChevronRight;
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, __assign({}, rest, { ref: ref }),
            title,
            React.createElement("span", null,
                React.createElement(Icon, { size: 10 }))),
        show && children));
}
export default forwardRef(FSFormSection);
var templateObject_1;
